module.exports = __webpack_public_path__ + "static/media/icon_greater_than_or_equal_to.adeca71a.svg";